import { useEffect, useState } from "react";

import { Rate } from "antd";
import React from "react";
import { StatusWorking } from "../../constants/enum";
import classNames from "classnames";
import { displayStaffName } from "utils/helper/common";
import styles from "./styles.module.scss";
import { updateHostStar } from "../../api/host";
import { useMutation } from "react-query";

interface IProps {
  id: number | string;
  staffName: string;
  onDragStart?: any;
  dragEnter?: any;
  dragEnd?: any;
  cls?: any;
  statusWorking?: StatusWorking;
  star?: number;
  style?: any;
  disableShowStar?: boolean;
  disableDragable?: boolean;
  backgroundWhite?: boolean;
  backgroundWhiteCandidacy?: boolean;
  isDuplicate?: boolean;
  count?: number;
  priority?: boolean;
  showPriority?: boolean;
  onChangeStart?: (star: number) => void;
}

function StaffComponent({
  id,
  staffName,
  cls,
  onDragStart,
  dragEnter,
  dragEnd,
  statusWorking,
  star,
  style,
  disableShowStar,
  disableDragable,
  backgroundWhite,
  backgroundWhiteCandidacy,
  isDuplicate,
  count,
  priority,
  showPriority,
  onChangeStart,
}: IProps) {
  const [showRate, setShowRate] = useState<boolean>(false);
  const [starStaff, setStar] = useState<number>(0);

  const updateStarOrder = useMutation(updateHostStar);
  useEffect(() => {
    setStar(star || 0);
  }, [star]);
  const handleShowRate = () => {
    if (!!disableShowStar) return;
    setShowRate(true);
    setTimeout(() => {
      setShowRate(false);
    }, 5000);
  };

  const handleChangeRate = (value: number) => {
    if (value === 0) {
      setShowRate(false);
    }
    setStar(value);
    onChangeStart && onChangeStart(value);
    updateStarOrder.mutate({
      id,
      data: {
        star: value,
      },
    });
  };

  return (
    <div className={styles.staffSection}>
      {(!!showRate || !!starStaff) && (
        <Rate
          className={styles.rate}
          count={1}
          value={starStaff}
          onChange={handleChangeRate}
          disabled={!onChangeStart}
          // style={{ color: "#fadb14" }}
        />
      )}
      {!!count && <div className={styles.count}>{count}</div>}
      <li
        key={id}
        draggable={disableDragable ? false : true}
        onDragStart={onDragStart}
        onClick={handleShowRate}
        style={style || {}}
        className={classNames(cls, "staffContainer", {
          [styles.notSetWorking]:
            !statusWorking ||
            [StatusWorking.Working, StatusWorking.WorkingLate].includes(
              statusWorking
            ),
          [styles.working]:
            !!statusWorking &&
            [StatusWorking.Working, StatusWorking.WorkingLate].includes(
              statusWorking
            ),
          [styles.workingLate]:
            statusWorking &&
            [StatusWorking.WorkingLate].includes(statusWorking),
          [styles.notPriority]: !!priority && showPriority,
        })}
        onDragEnter={dragEnter}
        onDragEnd={dragEnd}
      >
        {isDuplicate && <div className={styles.isDuplicate}>!</div>}
        {backgroundWhite ? (
          <div
            className={classNames(styles.backgroundWhite, "backgroundWhite", {
              [styles.backgroundWhiteCandidacy]: backgroundWhiteCandidacy,
            })}
          >
            <div className={styles.backgroundNormal}>
              {displayStaffName(staffName)}
            </div>
          </div>
        ) : (
          <div className={styles.backgroundNormal}>
            {displayStaffName(staffName)}
          </div>
        )}
      </li>
    </div>
  );
}
export default StaffComponent;
